import { useSweepApi } from '../sweep';
import { useCallback } from 'react';
import {
  CreateRollupDto,
  DeployRollupDto,
  RollupDto,
  UpdateRollupDto,
} from '../../components/pages/rollups/rollupTypes';

export const useRollupsApiFacade = () => {
  const sweepApi = useSweepApi();
  return {
    get_rollup: useCallback(
      async (rollupId: string, crmOrgId?: string, readOnly: boolean = false) => {
        const { data } = await sweepApi.get<RollupDto>(
          `/rollups/${rollupId}?crmOrgId=${crmOrgId}&includeReadOnly=${readOnly}`,
        );
        return data;
      },
      [sweepApi],
    ),
    get_rollups: useCallback(async () => {
      const { data } = await sweepApi.get<RollupDto[]>(`/rollups`);
      return data;
    }, [sweepApi]),
    create_rollup: useCallback(
      async (createRollupDto: CreateRollupDto) => {
        const { data } = await sweepApi.post<RollupDto>(`/rollups`, createRollupDto);
        return data;
      },
      [sweepApi],
    ),
    update_rollup: useCallback(
      async (rollupId: string, versionId: string, updateRollupDto: UpdateRollupDto) => {
        const { data } = await sweepApi.put<RollupDto>(
          `/rollups/${rollupId}/${versionId}`,
          updateRollupDto,
        );
        return data;
      },
      [sweepApi],
    ),
    deploy_rollup: useCallback(
      async (rollupId: string, versionId: string, deployRollupDto: DeployRollupDto) => {
        const { data } = await sweepApi.post<RollupDto>(
          `/rollups/${rollupId}/${versionId}`,
          deployRollupDto,
        );
        return data;
      },
      [sweepApi],
    ),
    delete_rollup: useCallback(
      async (rollupId: string) => {
        const { data } = await sweepApi.delete<boolean>(`/rollups/${rollupId}`);
        return data;
      },
      [sweepApi],
    ),
    patch_rollup_admin_notification: useCallback(
      async (automationId: string, versionId: string, note: string) => {
        await sweepApi.patch(`/rollups/admin-notification/${automationId}/${versionId}`, {
          note,
        });
      },
      [sweepApi],
    ),
  };
};
